export default __webpack_public_path__ + "static/media/hat.6feec3bf.svg";